
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".4","d":"M4.01 3.897h9.677V.267l-2.42 1.21L8.85.267l-2.42 1.21L4.01.267v3.63z","fill":"#F4B740"}}),_c('path',{attrs:{"d":"M5.462 11.759h.632a6.576 6.576 0 005.51 0h.632a5.08 5.08 0 015.08 5.08v.968A1.814 1.814 0 0115.5 19.62H2.196a1.814 1.814 0 01-1.814-1.814v-.968a5.08 5.08 0 015.08-5.08zm3.387-1.21A4.838 4.838 0 014.01 5.711v-.605h9.677v.605a4.839 4.839 0 01-4.838 4.838z","fill":"#F4B740"}})])
          )
        }
      }
    